/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IWizardImportPersonalDataValidation } from './types/wizardImportPersonalDataTypes';
import { initWizardImportPersonalDataState } from './wizardImportPersonalDataConstant';
import {
    IWizardImportPersonalDataReducer,
} from './wizardImportPersonalDataReducer';

export const makeSelectWizardImportPersonalDataState = (state: IRootReducer): IWizardImportPersonalDataReducer =>
    state.wizardImportPersonalData || initWizardImportPersonalDataState;

export const makeSelectWizardImportPersonalDataValidation = ():
    OutputSelector<IRootReducer, IWizardImportPersonalDataValidation,
        (state: IWizardImportPersonalDataReducer) => IWizardImportPersonalDataValidation> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.validation);

export const makeSelectWizardImportPersonalDataMaxImportSubscriberAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportPersonalDataReducer) => number> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.maxImportSubscriberAmount);

export const makeSelectWizardImportPersonalDataFileTemplateUrl = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportPersonalDataReducer) => string> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.fileTemplateUrl);

export const makeSelectWizardImportPersonalDataFileName = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportPersonalDataReducer) => string> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.fileName);

export const makeSelectWizardImportPersonalDataFileRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportPersonalDataReducer) => number> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.fileRowsAmount);

export const makeSelectWizardImportPersonalDataAttachFileErrorCode = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardImportPersonalDataReducer) => string> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.errorCode);

export const makeSelectWizardImportPersonalDataErrorRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportPersonalDataReducer) => number> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.errorRowsAmount);

export const makeSelectWizardImportPersonalDataRemovedRowsAmount = ():
    OutputSelector<IRootReducer, number,
        (state: IWizardImportPersonalDataReducer) => number> =>
    createSelector(makeSelectWizardImportPersonalDataState, state => state.removedRowsAmount);
